import { Component, NgZone, ViewEncapsulation, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { environment } from '../../../environments/environment';

// Services
import { LoginService, NotifyService, TitleService } from '../../services/service.index';

import { ImgUrlSanitizerPipe } from '../../pipes/sanitizerImgUrl.pipe';

import { HeaderComponent } from '../../components/shared/header/header.component';
import { FooterComponent } from '../../components/shared/footer/footer.component';
import { NotifierModule } from 'angular-notifier';

declare const gapi: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ImgUrlSanitizerPipe, CommonModule,FormsModule,HeaderComponent,FooterComponent,NotifierModule], 

})
export class LoginComponent implements OnInit {

  // Google Auth
  public auth2: any;

  // Modelo user
  usuario = {
    user: '',
    password: ''
  };

  // Modelo Google user
  userGoogle = {
    name: '',
    email: '',
    image: '',
    id: '',
    token: ''
  };

  loading = false;
  url;
  loadingTab = false;
  image: string;
  version: string;

  constructor(
    private router: Router,
    private _loginService: LoginService,
    private _notifyService: NotifyService,
    private _titleService: TitleService,
    private _ngZone: NgZone,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Asigna la class noScroll (obliga a ocultar scroll)
    this.document.body.classList.add('noScroll');

    console.info(`Versión:${environment.version}`);
    console.info(`Ambiente: ${environment.ambiente}`);

    // localStorage.clear();
    localStorage.removeItem('permisosUnicos');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');

    // Título página
    this._titleService.setTitle('Ingreso');

    localStorage.setItem('image', "data:image/png;base64,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");

    this.version = `${environment.version}`;
  }

  ngOnInit(): void {
    this._loginService.logout().subscribe((result: any) => {
      // Cierra sesión actual
    });
    this.route.queryParams.subscribe(params => {
      this.url = params['url'];
    });

    // Consulta la imagen en el localstorage
    const storedImage = localStorage.getItem('image');
    if (storedImage !== null) {
      this.image = storedImage;
    }
  }

  // Google Auth
  public googleInit() {
    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id: '241776108689-9ipujgfg70qb5v77b2e3i6evd1ccd6it.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope: 'profile email'
      });
      this.attachSignin(document.getElementById('googleBtn'));
    });
  }

  public attachSignin(element) {
    this.auth2.attachClickHandler(element, {},
      (googleUser) => {
        let profile = googleUser.getBasicProfile();
        this.userGoogle.name = profile.getName();
        this.userGoogle.id = profile.getId();
        this.userGoogle.image = profile.getImageUrl();
        this.userGoogle.email = profile.getEmail();
        this.userGoogle.token = googleUser.getAuthResponse().id_token;

        this.login(this.userGoogle);

      }, (error) => {
        if (error.error === 'popup_closed_by_user') {
          return;
        } else {
          this._notifyService.notifyErrServer('Error al conectar con Google');
        }
      });
  }

 /* ngAfterViewInit() {
    this.googleInit();
  }
*/
  // Método inicio de sesión
public login(user: any) {
  console.log('🔐 Iniciando login con usuario:', user);
  this.loading = true;
  this.loadingTab = true;

  this._loginService.login(user).subscribe(
    (result: any) => {
      console.log('📥 Respuesta del login:', result);

      if (result !== undefined) {
        if (result.user.user[0] === 'annm' && result.role[0].role[0] === 'annm') {
          console.error('⛔ Usuario bloqueado "annm", acceso denegado');
          this.loadingTab = false;
          this._ngZone.run(() => {
            this._notifyService.notifyErrIngreso('Datos inválidos, compruebe usuario y contraseña');
          });
          this.loading = false;
          return;
        }

        // Guardar en localStorage
        localStorage.setItem('currentUser', JSON.stringify(result));
        console.log('💾 Guardado currentUser en localStorage');

        if (user.token) {
          localStorage.setItem('token', JSON.stringify(user.token));
          localStorage.setItem('image', JSON.stringify(user.image));
          console.log('🧾 Token e imagen guardados');
        } else {
          localStorage.removeItem('image');
          console.log('🧽 Imagen eliminada del localStorage (no vino token)');
        }

        let localUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('📤 Usuario recuperado del localStorage:', localUser);

        if (localUser !== null) {
          console.log('🔍 Verificando currentUser con backend...');
          this._loginService.currentUser().subscribe((current: any) => {
            console.log('📥 currentUser backend:', current);

            if (current.user.user[0] === localUser.user.user[0]) {
              console.log('✅ Usuario validado correctamente');

              // Redirección
              if (this.url !== undefined) {
                console.log('➡️ Redireccionando a URL con queryParams:', this.url);
                this._ngZone.run(() => {
                  this.router.navigate(['sifac/home'], { queryParams: { url: this.url } });
                });
              } else {
                console.log('➡️ Redireccionando directo a /sifac/home');
                this._ngZone.run(() => {
                  this.router.navigateByUrl('/sifac/home');
                });
              }

              this.loading = false;
            } else {
              console.error('⚠️ Usuario del backend no coincide con el localStorage');
              localStorage.removeItem('currentUser');
              localStorage.removeItem('permisosUnicos');
              this._ngZone.run(() => {
                this._notifyService.notifyErrIngreso('Usuario no validado');
              });
              this.loading = false;
              this.loadingTab = false;
            }
          });
        } else {
          console.error('⚠️ localUser es null');
          this._ngZone.run(() => {
            this._notifyService.notifyErrIngreso('Usuario no validado');
          });
          this.loading = false;
          this.loadingTab = false;
        }
      } else {
        console.error('❌ El servicio no devolvió usuario');
        this._ngZone.run(() => {
          this._notifyService.notifyErrIngreso('Error, el servicio no devolvió usuario, contacte con soporte');
        });
        this.loading = false;
        return;
      }
    },
    (err) => {
      console.error('🚨 Error al conectar con backend:', err);
      this.loading = false;
      this._ngZone.run(() => {
        this._notifyService.notifyErrServer('Error al tratar de conectar al Servicio, contacte con soporte');
      });
    }
  );
}


  // Activa pantalla de carga para login google
  load() {
    this.loadingTab = true;
  }

  // Elimina la class noScroll del body
  ngOnDestroy(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('noScroll');
  }
}
